import axios from "axios";
import { getCookie, setCookie, deleteCookie } from "@/lib/cookies";
import { API_URL } from "@/env";
import { showCustomToast } from "@/components/CustomToast";
import { getDeviceInfo } from "@/utils/getDeviceInfo";

interface LoginResponse {
  access_token: string;
}

export async function login(email: string, password: string) {
  try {
    const response: any = await axios.post<LoginResponse>(
      `${API_URL}/auth/login`,
      {
        email,
        password,
      }
    );
    if (response.data.access_token) {
      setCookie("token", response.data.access_token, {
        expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
      });
    }
    return response.data;
  } catch (error) {
    throw new Error("Invalid credentials");
  }
}

export async function register(
  email: string,
  username: string,
  password: string,
  gradient: number
) {
  const data = await axios.post<any>(`${API_URL}/auth/signup`, {
    email,
    password,
    username,
    gradient,
    deviceInfo: getDeviceInfo(),
  });

  return data;
}

export async function registerWithEmail(email: string) {
  try {
    const res = await fetch(`${API_URL}/auth/signup/email-only`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (data?.access_token) {
      setCookie("token", data.access_token, {
        expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
      });
    }
    return data;
  } catch (error: any) {
    console.log({ error });
  }
}

export function getToken(): string | null {
  return getCookie("token");
}

export function logout(): void {
  deleteCookie("token");
}
